<template>
  <ul class="main_list" v-if="info">
    <template v-if="info.type === 'name'">
      <li v-for="(item, index) in info.list.slice(0, 5)" :key="item.id">
        <span class="rank">{{ index + 1 }}</span>
        <span class="name" @click="movieClick(item)">{{ item.name }}</span>
      </li>
    </template>
    <template v-if="info.type === 'image'">
      <li v-for="item in info.list" :key="item.id" style="cursor: pointer" @click="movieClick(item)">
        <img :src="item.src" />
        <div class="column1">{{ item.name }}</div>
        <div class="column2">{{ item.description }}</div>
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  name: 'Seniority',
  props: { info: Object },
  methods: {
    movieClick(item) {
      this.$emit('movieClick', item)
    }
  }
}
</script>

<style lang="scss" scoped>

.main_list {
  width: 270px;
  background: #f8f8f8;
  border-radius: 5px;
  padding: 17px 26px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  list-style: none;

  li {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 10px;

    .rank {
      margin-right: 22px;
      font-family: PingFang;
      font-weight: 700;
      font-size: 16px;
      color: #000;
      font-style: italic;
    }

    &:nth-child(1) .rank,
    &:nth-child(2) .rank,
    &:nth-child(3) .rank {
      color: #d70002;
    }

    .name {
      font-family: PingFang;
      font-size: 16px;
      color: #000;
    }

    &:nth-child(1) .name,
    &:nth-child(2) .name,
    &:nth-child(3) .name {
      font-weight: 700;
    }
  }
}
</style>
